module.exports = __webpack_public_path__ + "img/SberMarketing.e6984cd6.png";